export const transfereeStatusOptions = [
  { label: 'Active', value: 'Active' },
  { label: 'Closed - Services Complete', value: 'Closed - Services Complete' },
  { label: 'Closed - No Services', value: 'Closed - No Services' },
]

export const roleNamesMap = {
  admin:        'Admin',
  dc:           'Destination Counselor',
  dg:           'Destination Guide',
  ho:           'Housing Officer',
  relo_company: 'Relo Company',
  super_admin:  'Super Admin',
}

export const todoLabels = {
  first_contact: 'First Contact',
  follow_up: 'Follow Up',
}

export const todoTypeOptions = [
  {label: 'Todo', value: null},
  {label: 'First Contact', value: 'first_contact'},
  {label: 'Follow Up', value: 'follow_up'},
]

export const transfereeCategoryOptions = [
  { id: 'transferee', name: 'Transferee', },
  { id: 'candidate', name: 'Candidate', },
  { id: 'assignee', name: 'Assignee', },
]

export const billingTypeOptions = [
  { value: 'half_day', label: 'Half Day - $225', price: 225.0 },
  { value: 'full_day', label: 'Full Day - $360', price: 360.0 },
  { value: 'hourly', label: 'Hourly', price: null },
]

export const expenseOptions = [
  { value: "Gift Basket", label: "Gift Basket" },
  { value: "Rental Car", label: "Rental Car" },
  { value: "Food", label: "Food" },
  { value: "Out of Area Premium", label: "Out of Area Premium" },
  { value: "Misc", label: "Misc" },
]